import { FETCHING_USERROLE_START,
  FETCHING_USERROLE_SUCCESS } from './actiontypes';

import { db } from '../connection';
import { fetch } from '../helper/firebaseFunctions';

export function fetchUserRole(fetchAllUsersFlag = false) {
  return (dispatch) => {
    dispatch({type : FETCHING_USERROLE_START});
    mergeData(fetchAllUsersFlag).then((finalObj) => {
      dispatch({type : FETCHING_USERROLE_SUCCESS, payload : finalObj });
    })
  }
}

async function mergeData(fetchAllUsersFlag) {
  let employeeList = await fetchEmployeeList();
  let teams = await fetchDeliveryMapping();
  let userRoles = await Promise.all(employeeList.map(async user => {
    user.webRole = await fetchWebRole(user.userid);
    user.name = user.fname + " " + user.lname;
    user.deliveryRole = [];
    if(user.role <= 100 && user.webRole < 1600) user.isCustomer = true;
    Object.values(teams).forEach((team) => {
      if(Object.keys(team.members).includes(user.userid)){
        let obj = {
          teamName : team.teamName,
          role : team.members[user.userid].role,
          roleDescription : team.members[user.userid].roleDescription
        }
        user.deliveryRole.push(obj);
      }
    })
    return user;
  }))
  if(!fetchAllUsersFlag) {
    userRoles = userRoles.filter(row => !row.isCustomer)
  }
  let finalObj = {userRoles : userRoles, teams: teams};
  return finalObj;
}

async function fetchEmployeeList() {
  let snapshot = await db.ref("/employeelist").once("value");
  let employeeList = snapshot.val();
  return Object.values(employeeList);
}

async function fetchWebRole(user) {
  try{
    let snapshot = await db.ref("/webDelivery/userrolemapping").child(user).once("value");
    let webRole = snapshot.val();
    return webRole;
  }
  catch(e){
    console.log("user", user);
    return '';
  }
}

async function fetchDeliveryMapping() {
  let snapshot = await db.ref("/delivery/teamtoEmployeeMapping").once("value");
  let teams = snapshot.val();
  // Object.keys(teams).forEach((team) => {
  //   let teamNumber = parseInt(team.slice(4))
  //   if( teamNumber < 8 || teamNumber > 15){
  //     delete teams[team];
  //   }
  // })
  return teams;
}

export function updateUserName(userId, userName, data, teams) {
  return async (dispatch) => {
    try {
      if(!userId || !userName.trim()) {
        alert("Error - Name cannot be empty");
        return;
      }
      let [ firstName, ...rest ] = userName.trim().split(' ');
      let lastName = rest.join(" ");
      await Promise.all([
        updateNameEmployeeList(userId, firstName, lastName),
        updateNameUsersList(userId, firstName, lastName)
      ]);
      data = data.map(row => {
        if(row.userid === userId) row.name = userName;
        return row;
      })
      dispatch({type : FETCHING_USERROLE_SUCCESS, payload : {userRoles : data, teams: teams} });
    }
    catch(error) {
      console.log("updateUserName error");
      return;
    }
  }
}

const updateNameEmployeeList = async (userId, firstName, lastName) => {
  try {
    if(!userId || !firstName) {
      return;
    }
    let employeeObj = await db.ref(`employeelist/${userId}`).once("value");
    if(employeeObj.val()) {
      await Promise.all([
        db.ref(`employeelist/${userId}/fname`).set(firstName),
        db.ref(`employeelist/${userId}/lname`).set(lastName || "")
      ])
    }
    return;
  }
  catch(error) {
    console.log("Error updateNameEmployeeList", error);
    return;
  }
}

const updateNameUsersList = async (userId, firstName, lastName) => {
  try {
    if(!userId || !firstName) {
      return;
    }
    let usersObj = await db.ref(`users/${userId}`).once("value");
    if(usersObj.val()) {
      await Promise.all([
        db.ref(`users/${userId}/mUser_Contact/mContact_FirstName`).set(firstName),
        db.ref(`users/${userId}/mUser_Contact/mContact_LastName`).set(lastName || "")
      ])
    }
    return;
  }
  catch(error) {
    console.log("Error updateNameUsersList", error);
    return;
  }
}